/* Fit the visible product, including photos with white or transparent borders. */
(() => {
  const bounds = new WeakMap();
  const watched = new WeakSet();
  function fit(img) {
    const box = bounds.get(img);
    if (!box || !img.clientWidth || !img.clientHeight) return;
    const w = img.clientWidth, h = img.clientHeight;
    const ratio = img.naturalWidth / img.naturalHeight;
    const rw = Math.min(w, h * ratio), rh = rw / ratio;
    const scale = Math.min((w - 12) / (box.width * rw), (h - 12) / (box.height * rh), 2.5);
    if (scale <= 1.08) { img.style.transform = ''; return; }
    const x = (0.5 - box.x) * rw * scale;
    const y = (0.5 - box.y) * rh * scale;
    img.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
  }
  const resize = new ResizeObserver(entries => entries.forEach(({target}) => fit(target)));
  function measure(img) {
    if (!img.naturalWidth) return;
    try {
      const canvas = document.createElement('canvas');
      const ratio = img.naturalWidth / img.naturalHeight;
      canvas.width = Math.max(1, Math.round(Math.min(160, 160 * ratio)));
      canvas.height = Math.max(1, Math.round(canvas.width / ratio));
      const ctx = canvas.getContext('2d', {willReadFrequently: true});
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      const {data} = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const blank = (x, y) => {
        const i = (y * canvas.width + x) * 4;
        return data[i + 3] < 16 || (data[i] >= 245 && data[i + 1] >= 245 && data[i + 2] >= 245);
      };
      // Only normalize studio photos; keep lifestyle images in their original frame.
      const corners = [[0,0],[canvas.width-1,0],[0,canvas.height-1],[canvas.width-1,canvas.height-1]];
      if (!corners.every(([x,y]) => blank(x,y))) return;
      let left = canvas.width, right = -1, top = canvas.height, bottom = -1;
      for (let y = 0; y < canvas.height; y++) for (let x = 0; x < canvas.width; x++) {
        if (!blank(x,y)) { left=Math.min(left,x);right=Math.max(right,x);top=Math.min(top,y);bottom=Math.max(bottom,y); }
      }
      if (right < left || bottom < top) return;
      // Retain a generous safety border for white finishes and JPEG edge detail.
      left=Math.max(0,left-5);right=Math.min(canvas.width,right+6);
      top=Math.max(0,top-5);bottom=Math.min(canvas.height,bottom+6);
      bounds.set(img,{x:(left+right)/2/canvas.width,y:(top+bottom)/2/canvas.height,width:(right-left)/canvas.width,height:(bottom-top)/canvas.height});
      fit(img);
      resize.observe(img);
    } catch (_) { /* Cross-origin images retain the standard uncropped fit. */ }
  }
  const visible = new IntersectionObserver(entries => entries.forEach(({target,isIntersecting}) => {
    if (!isIntersecting) return;
    visible.unobserve(target);
    if (target.complete) measure(target);
    target.addEventListener('load', () => measure(target));
  }), {rootMargin:'300px'});
  function scan(root) {
    root.querySelectorAll('.ks-card__image img').forEach(img => {
      if (watched.has(img)) return;
      watched.add(img);visible.observe(img);
    });
  }
  scan(document);
  new MutationObserver(entries => entries.forEach(entry => entry.addedNodes.forEach(node => {
    if (node.nodeType === 1) scan(node);
  }))).observe(document.body,{childList:true,subtree:true});
})();
